import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from "./store"

// Force light theme on app initialization
if (typeof window !== "undefined") {
  const root = document.documentElement;
  root.setAttribute("data-eeap-theme", "light");
  try {
    window.localStorage.setItem("eeap-theme", "light");
  } catch (e) {}
  document.body.classList.remove("eeap-dark-header");
  document.body.classList.add("eeap-light-header");
}

const root = ReactDOM.createRoot(document.getElementById('quarter'));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
